// ✅ Step 1: First button — open description panel instead of variant selector
document.addEventListener(
  "click",
  function (e) {
    const chooseBtn = e.target.closest(".mu-fbt-item-atc");
    if (!chooseBtn) return;

    const item = chooseBtn.closest(".mu-fbt-item");
    if (!item) return;

    const title = item.querySelector(".mu-fbt-item-title");
    if (!title || !title.textContent.includes("Extra Embosser Design")) return;

    // Stop default behaviour
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // Open description panel
    const moreInfoBtn = item.querySelector(".mu-fbt-item-link.mu-btn-link");
    if (moreInfoBtn) {
      moreInfoBtn.click();
    }
  },
  true // Capture to intercept before app
);

// ✅ Step 2: REMOVE the redirect for the second button
// Do NOTHING here now so quantity selector works normally
